import { Icon } from '@jurnee/common/src/components/Icon';
import { Text, TextProps } from '../primitives/Text';
import { HStack } from '../primitives/stack/HStack';

interface Props {
  label: string;
  name: string | undefined;
  maxW: TextProps['maxW'];
  isSavedFile: boolean | undefined;
}

export function Label({ label, name, maxW, isSavedFile }: Props) {
  const textTruncateProps = {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
  } as const;

  if (!name) {
    return <Text lineHeight="16px" {...textTruncateProps}>{label}</Text>;
  }

  return (
    <HStack spacing={1}>
      <Text maxW={maxW} lineHeight="16px" {...textTruncateProps}>{decodeURIComponent(name)}</Text>
      { isSavedFile && <Icon icon="circleCheckLine" color="teal.400" size={4} /> }
    </HStack>
  );
}